<template>
    <div>
        <component
            :is="stepForm"
            :amounts="amounts"
            :paymentType="paymentType" />
    </div>
</template>

<script>
import MonthlyFirstStepForm from "@/components/organisms/MonthlyFirstStepForm.vue";

export default {
    name: 'MonthlyPaymentStepOne',
    inject: ['$validator'],
    data () {
        return {
            onePage: false,
            amounts: this.$store.state.amountList,
            currentAmount: this.$store.state.currentAmount,
            paymentType: 'subscription',
        }
    },
    computed: {
        stepForm () {
            return 'MonthlyFirstStepForm';
        }
    },
    components: {
        MonthlyFirstStepForm,
    }
}
</script>

<style scoped>
</style>
